(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["block22"] && !Shopify.designMode) return;
  try {
    (function () {
    function markActive(root) {
      var path = location.pathname.replace(/\/+$/, '');
      root.querySelectorAll('.pb-vc__item').forEach(function (item) {
        var a = item.querySelector('a');
        if (!a) return;
        var raw = a.getAttribute('href');
        if (!raw || raw === '#' || raw.charAt(0) === '#') return;
        try {
          if (new URL(a.href).pathname.replace(/\/+$/, '') === path) {
            item.classList.add('is-active');
          }
        } catch (e) {}
      });
    }

    function init() {
      document.querySelectorAll('.pb-vc').forEach(markActive);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:block:select', init);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["block24"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.pb-faq[data-single-open="true"]').forEach(function(wrap){
  if(wrap.dataset.pbBound === '1') return;
  wrap.dataset.pbBound = '1';
  var items = Array.prototype.slice.call(wrap.querySelectorAll('details'));
  items.forEach(function(d){
    d.addEventListener('toggle', function(){
      if(!d.open) return;
      items.forEach(function(o){ if(o !== d) o.open = false; });
    });
  });
});
  } catch(e) { console.error(e); }
})();

})();
